import { environmentConfig } from "@src/appV2/environment";

/**
 * Image width for badge verification photos.
 */
export const BADGE_VERIFICATION_IMAGE_WIDTH = 1024;

/**
 * Base URL for contractor badge verification API endpoints.
 */
export const CONTRACTOR_BADGE_VERIFICATIONS_URL = `${environmentConfig.REACT_APP_BASE_API_URL}/contractor-badge-verifications`;

/**
 * Badge verification flow types for analytics tracking.
 */
export const BADGE_VERIFICATION_FLOW = {
  UPLOAD: "upload",
  SKIP: "skip",
} as const;
